export const layoutConfig = {
  grid: {
    name: 'grid',
    next: 'flow',
  },
  flow: {
    name: 'flow',
    next: 'grid',
  },
};
export const defaultLayout = layoutConfig.grid.name;
